import LoadingOutlined from "@ant-design/icons/LoadingOutlined"

export function LoadingSpinner(props: {fontSize?: string, className?: string}) {
  return <LoadingOutlined className={`loading-spinner ${props.className && props.className}`} style={{ fontSize: props.fontSize ? props.fontSize : '1em' }} spin />;
}